export function clientId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return `c_${crypto.randomUUID()}`
  return `c_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`
}
